import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL, IEncryptedAccountDto } from '@/dtos';
import { BankInfo } from '@/modules/employer/components/SetupEmployer/SetupEmployer.types';

const ALLOWED_ACCOUNT_TYPE = 'EXTERNAL';
const last4length = 4;
const accountsCountLimit = 100;


export const formatBankDetails = (bankDetails: IEncryptedAccountDto): BankInfo => ({
  id: `${bankDetails.id}`,
  // TODO: this field is missing
  // @ts-ignore
  type: bankDetails.type,
  description: bankDetails.description || '',
  // TODO: this field is missing
  // @ts-ignore
  contactId: bankDetails.contactId,
  accountCategory: bankDetails.account_category as string,
  accountType: bankDetails.account_type || '',
  availableBalance: bankDetails.available_balance || 0,
  createdAt: bankDetails.created_at as unknown as string,
  employeeId: bankDetails.employee_id || 0,
  leafNode: bankDetails.leaf_node || false,
  liveBalance: bankDetails.live_balance || 0,
  modifiedAt: bankDetails.modified_at as unknown as string,
  // TODO: the field is missing
  // @ts-ignore
  number: bankDetails.number
    ? // @ts-ignore
      bankDetails.number
    : // @ts-ignore
      `${Array(bankDetails.number_length - last4length)
        .fill('•')
        .join('')}${bankDetails.account_number_last4}`,
  onDepositBalance: bankDetails.on_deposit_balance || 0,
  organizationId: bankDetails.organization_id || 0,
  parentAccountId: bankDetails.parent_account_id || 0,
  // TODO: the field is missing
  // @ts-ignore
  postings: bankDetails.postings,
  routingTransitNumber: bankDetails.routing_transit_number || '',
  // TODO: the field is missing
  //@ts-ignore
  statusType: bankDetails.status_type,
  accountNumberLast4: bankDetails?.account_number_last4 || '',
  accountNumberLength: bankDetails?.number_length || 0,
});

export default (organizationId?: string) => {
  const { isLoading, isSuccess, isError, data, isFetched } = useQuery(
    [API_URL.ORGANIZATIONS_ACCOUNTS_BY_ORGANIZATION_ID(organizationId || '')],
    () =>
      api.get(API_URL.ORGANIZATIONS_ACCOUNTS_BY_ORGANIZATION_ID(organizationId || ''), {
        params: { size: accountsCountLimit },
      }),
    {
      enabled: !!organizationId,
    }
  );
  const formatedBanks = useMemo(
    () =>
      (data?.data?.content || [])
        .filter((bank) => bank?.account_type === ALLOWED_ACCOUNT_TYPE)
        .map((bank) => formatBankDetails(bank)),
    [data]
  );

  const options = useMemo<Option[]>(
    () =>
      formatedBanks.map((item) => ({
        key: item.id,
        value: item.description,
        title: item.description,
      })),
    [formatedBanks]
  );
  return {
    banks: formatedBanks,
    data: data?.data || [],
    isError,
    options,
    isLoading,
    isSuccess,
    isFetched,
  };
};
